
import axios from "axios";
import { ref, defineComponent } from "vue";
import router from "@/router";
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { UserTypes } from "@/static/UserTypes";
export default defineComponent({
  setup() {
    const email = ref("eve.holt@reqres.in");
    const password = ref("cityslicka");
    const userType = ref(UserTypes.Customer);
    const loading = ref(false);
    const $q = useQuasar();
    const { setValue: setToken } = useLocalStorage("token");
    const { setValue: setUserType } = useLocalStorage("userType");
    const onSubmit = async () => {
      loading.value = true;
      try {
        const { data } = await axios.post<{ token: string }>(
          "https://reqres.in/api/login",
          { email: email.value, password: password.value }
        );
        loading.value = false;
        if (data.token) {
          setToken(data.token);
          setUserType(userType.value);
          router.push("/");
        }
      } catch (error) {
        $q.notify({
          message: `Login Unsuccessful`,
          color: "primary",
        });
        loading.value = false;
      }
    };
    return { email, password, userType, loading, onSubmit, UserTypes };
  },
});
